import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import ReactDOM from "react-dom";
import "../modal.css";
import { useAuthStore } from "../../../store/useAuthStore";
import { toast } from "react-toastify";

const ForgotPasswordPopup = ({ onClose, enablePopup, setUserId }) => {

  const {getOtp} = useAuthStore()

  const handleGetOtp = async (email) => {
    const response = await getOtp(email)
    console.log(response, 'get otp')
    if(response?.status) {
      toast.success(response?.message)
      setUserId(response?.userId)
      enablePopup();
    } else {
      toast.error(response?.message ?? 'something went wrong', {toastId: 'errorMessageGetOtp'})
    }
  }

  const formik = useFormik({
    initialValues: {
      contact: "",
    },
    validationSchema: Yup.object({
      contact: Yup.string()
        .test("email", "Enter a valid email", (value) => {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return emailRegex.test(value)
        })
        .required("Email is required"),
    }),
    onSubmit: (values) => {
      handleGetOtp(values.contact)
    },
  });

  return ReactDOM.createPortal(
    <>
      <div className="custom-modal-backdrop" onClick={onClose}></div>
      <div className="custom-modal">
        <div className="custom-modal-content">
          <div className="custom-modal-header">
            <h5 className="custom-modal-title">Enter Your Email to get OTP</h5>
            <button className="custom-close-btn" onClick={onClose}>&times;</button>
          </div>
          <div className="custom-modal-body">
            <form onSubmit={formik.handleSubmit}>
              <input type="text" className="custom-input" placeholder="Enter email" {...formik.getFieldProps("contact")} />
              {formik.touched.contact && formik.errors.contact && <div className="error-text">{formik.errors.contact}</div>}

              <div className="custom-modal-footer">
                <button type="submit" className="inline-flex w-full justify-center rounded-md bg-emerald-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-emerald-500 sm:ml-3 sm:w-auto">Get OTP</button>
                <button type="button" className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50 sm:mt-0 sm:w-auto" onClick={onClose}>Close</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>,
    document.getElementById("popup-root")
  );
};

export default ForgotPasswordPopup;
